import { useMemo } from 'react';

interface Post {
    author?: string;
    author_photo?: string;
    link: string;
    text: string;
}

interface Social {
    reddit?: { posts: Post[] };
    twitter?: { tweets: Post[] };
}

export default function useSocialMediaPosts(social: Social) {
    const posts = useMemo(() => {
        return [...(social.reddit?.posts ?? []), ...(social.twitter?.tweets ?? [])].map(
            ({ text, link, author, author_photo }) => ({
                link,
                text: text.replaceAll(/\/hashtag\/([A-Za-z0-9-_]+)\?src=hashtag_click/gi, (_, match) => `#${match}`),
                author: author ?? '',
                avatar: author_photo ?? ''
            })
        );
    }, [social]);

    return posts;
}
